import { takeLatest } from 'redux-saga/effects'

import { login, logout, checkToken, refreshToken } from '../store/user.store';
import { loginUserSaga, logoutUserSaga, checkTokenSaga, refreshTokenSaga } from './user.saga';
import { usersGetListDataAction } from '../store/users.store';
import {
    userDetailAddObjectAction,
    userDetailGetObjectAction,
    userDetailUpdateObjectAction,
    userDetailDeleteObjectAction
} from '../store/userDetail.store';
import { stationsGetListDataAction } from '../store/stations.store';
import {
    stationDetailAddObjectAction,
    stationDetailGetObjectAction,
    stationDetailUpdateObjectAction,
    stationDetailDeleteObjectAction
} from '../store/stationDetail.store';

import { paginatedListSaga } from './paginatedList.saga';
import { addObjectSaga, deleteObjectSaga, getObjectSaga, updateObjectSaga } from './objectCRUD.saga';



function* sagas() {
    yield takeLatest(login.type, loginUserSaga);
    yield takeLatest(logout.type, logoutUserSaga);
    yield takeLatest(checkToken.type, checkTokenSaga);
    yield takeLatest(refreshToken.type, refreshTokenSaga);

    yield takeLatest(usersGetListDataAction.type, paginatedListSaga)
    yield takeLatest(userDetailGetObjectAction.type, getObjectSaga)
    yield takeLatest(userDetailUpdateObjectAction.type, updateObjectSaga)
    yield takeLatest(userDetailAddObjectAction.type, addObjectSaga)
    yield takeLatest(userDetailDeleteObjectAction.type, deleteObjectSaga)

    yield takeLatest(stationsGetListDataAction.type, paginatedListSaga)
    yield takeLatest(stationDetailGetObjectAction.type, getObjectSaga)
    yield takeLatest(stationDetailUpdateObjectAction.type, updateObjectSaga)
    yield takeLatest(stationDetailAddObjectAction.type, addObjectSaga)
    yield takeLatest(stationDetailDeleteObjectAction.type, deleteObjectSaga)


}

export default sagas;
